<template>
  <div>
    <div class="pa-3">
      <div v-if="loading" class="text-xs-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else-if="type=='Supplier'">
        <div v-for="item in data2" :key="item.id" class="my-1">
          <v-card style="position: relative">
            <v-card-text>
              <v-layout>
                <v-flex xs6>
                  <div class="caption">{{item.id}}</div>
                </v-flex>
                <v-flex class="text-xs-right" xs6>
                  <div :style="{'color': item.status=='Approve'?'green':'red'}">{{item.status}}</div>
                </v-flex>
              </v-layout>
              <div class="pl-3">
                <div>
                  <a
                    v-if="item.credentials"
                    rel="noopener noreferrer"
                    target="_blank"
                    :href="item.credentials"
                  >หนังสือรับรอง/สำเนาบัตรประชาชน</a>
                  <div v-else style="color: lightgrey;">หนังสือรับรอง/สำเนาบัตรประชาชน</div>
                </div>
                <div>
                  <a
                    v-if="item.bookbank"
                    rel="noopener noreferrer"
                    target="_blank"
                    :href="item.bookbank"
                  >หน้าสมุดบัญชีธนาคาร</a>
                  <div v-else style="color: lightgrey;">หน้าสมุดบัญชีธนาคาร</div>
                </div>
                <div>
                  <a
                    v-if="item.quotation"
                    rel="noopener noreferrer"
                    target="_blank"
                    :href="item.quotation"
                  >ใบเสนอราคา</a>
                  <div v-else style="color: lightgrey;">ใบเสนอราคา</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'

export default {
  props: ['userid'],
  components: {
    Multiselect
  },
  data() {
    return {
      loading: true,
      type: 'Supplier',
      data: [],
      data2: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getallrenttransactionlivechat()
  },
  methods: {
    getallrenttransactionlivechat() {
      this.loading = true
      var data = {
        pageid: this.selectedBot.pageid,
        userid: this.userid
      }
      api.getallrenttransactionlivechat(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          this.data = response.data
          this.data2 = response.data2
        }
      })
    }
  },
  watch: {
    userid: function(newVal) {
      var vm = this

      if (newVal == null) {
        vm.data = []
        vm.data2 = []
      } else {
        vm.getallrenttransactionlivechat()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/livechat/scgallrent-supplier.vue